// Material UI
import { makeStyles } from '@material-ui/core'
// Consts
import Colors from './../../../constants/Colors'

export default makeStyles(theme => ({
  filterTitle: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontFamily: 'Poppins',
    fontSize: 17,
    fontWeight: 'normal',
    lineHeight: 'normal',
    marginBottom: 24,
    marginTop: 0,
  },
  listTitle: {
    color: Colors.SECONDARY_FONT_COLOR,
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 'normal',
    lineHeight: 'normal',
    marginBottom: 4,
    marginTop: 24,
  },
  searchIcon: {
    color: Colors.SECONDARY_FONT_COLOR,
  },
}))
